import React from "react";
import { Helmet } from "react-helmet-async";
import "./About.css";

const About = () => {
  const COMPANY_PROFILE_URL =
    "https://res.cloudinary.com/dndg4fwia/image/upload/v1773205445/RK_Company_Profile.pdf";
  const COMPANY_PROFILE_DOWNLOAD =
    "https://res.cloudinary.com/dndg4fwia/image/upload/fl_attachment/v1773205445/RK_Company_Profile.pdf";
  return (
    <div className="about-page">
      <Helmet>
        <title>
          About Us | RK Overseas — Glass Manufacturer Firozabad, India
        </title>
        <meta
          name="description"
          content="Learn about RK Overseas, a leading glass manufacturer and global exporter based in Firozabad, India since 1997. 28+ years of handcrafted glass excellence with worldwide export."
        />
        <meta
          name="keywords"
          content="about RK Overseas, glass manufacturer firozabad india, blown glass factory india, glass exporter since 1997, handcrafted glass firozabad"
        />
        <link rel="canonical" href="https://rkoverseasindia.com/about" />
      </Helmet>

      <div className="page-banner">
        <h1>About Us</h1>
        <p className="breadcrumb">Home / About Us</p>
      </div>

      <section className="section about-story">
        <div className="container">
          <div className="about-story__grid">
            <div className="about-story__content">
              <p className="about-story__eyebrow">Our Story</p>
              <h2>Crafting Timeless Glass Creations Since 1997</h2>
              <div
                className="section-divider"
                style={{ margin: "16px 0 24px" }}
              />
              <p>
                <strong>RK Overseas</strong> is a distinguished manufacturer and
                global exporter of premium home decorative accessories, proudly
                based in Firozabad — the renowned glass city of India.
              </p>
              <p style={{ marginTop: "14px" }}>
                Since our inception in 1997, also called as SKI, Sri Krishna
                Overseas and Radha Krishna Overseas, we have developed a fully
                integrated in-house blown glass manufacturing facility,
                combining skilled craftsmanship with modern production
                techniques to create distinctive and high-quality designs.
              </p>
              <p style={{ marginTop: "14px" }}>
                Our collections reflect a seamless blend of contemporary
                sophistication and timeless elegance, offering versatile designs
                suited for diverse lifestyles and international markets. We
                proudly export to numerous countries worldwide and actively
                participate in prestigious trade fairs IHGF Delhi, JP
                Exhibition, UPITS.
              </p>
            </div>
            <div className="about-story__image">
              <img
                src="https://res.cloudinary.com/dndg4fwia/image/upload/q_auto,f_auto,/v1772602760/Rani_Pink_For_Abhinav_Mishra_%EF%B8%8F_This_is_the_most_special_evening_and_event_for_me_every_single_y.jpg"
                alt="RK Overseas Factory"
              />
              <div className="about-story__exp">
                <span className="about-story__exp-num">28+</span>
                <span className="about-story__exp-text">
                  Years of Excellence
                </span>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section
        className="section about-values"
        style={{ background: "var(--cream)" }}
      >
        <div className="container">
          <h2 className="section-title">Why Choose Us?</h2>
          <div className="section-divider" />
          <div className="about-values__grid">
            {[
              {
                icon: "🏭",
                title: "Integrated Manufacturing",
                desc: "End-to-end in-house production ensuring complete control over quality, design, and finishing.",
              },
              {
                icon: "👨‍🎨",
                title: "Expert Craftsmanship",
                desc: "A dedicated team of experienced artisans creating refined, handcrafted glass collections.",
              },
              {
                icon: "🌍",
                title: "Global Presence",
                desc: "Serving international markets with participation in leading global trade exhibitions.",
              },
              {
                icon: "✨",
                title: "Commitment to Quality",
                desc: "Every piece is crafted with precision to meet international standards of excellence.",
              },
            ].map((v, i) => (
              <div className="about-values__card" key={i}>
                <div className="about-values__icon">{v.icon}</div>
                <h3>{v.title}</h3>
                <p>{v.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="section about-team">
        <div className="container" style={{ textAlign: "center" }}>
          <h2 className="section-title">Our Factory</h2>
          <div className="section-divider" />
          <p className="section-subtitle">
            Situated in Firozabad — the Glass City of India — our manufacturing
            facility seamlessly blends traditional artistry with modern
            innovation to deliver exceptional glass creations.
          </p>
          <div className="about-factory__grid">
            {[
              "https://res.cloudinary.com/dndg4fwia/image/upload/q_auto,f_auto,/v1772596355/Screenshot_2026-03-04_092214.png",
              "https://res.cloudinary.com/dndg4fwia/image/upload/q_auto,f_auto,/v1772596519/Screenshot_2026-03-04_092501.png",
              "https://res.cloudinary.com/dndg4fwia/image/upload/q_auto,f_auto,/v1772596664/Screenshot_2026-03-04_092432.png",
            ].map((src, i) => (
              <div className="about-factory__img" key={i}>
                <img src={src} alt={`Factory ${i + 1}`} loading="lazy" />
              </div>
            ))}
          </div>
        </div>
      </section>
      <section
        className="section about-profile"
        style={{ background: "var(--cream)" }}
      >
        <div className="container" style={{ textAlign: "center" }}>
          <h2 className="section-title">Company Profile</h2>
          <div className="section-divider" />
          <p className="section-subtitle">
            Download our official Company Profile for a complete overview of our
            products, capabilities, and export experience.
          </p>
          <div className="about-profile__actions">
            <a
              href={COMPANY_PROFILE_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="btn-primary"
              aria-label="View RK Overseas Company Profile PDF"
            >
              📄 View Profile
            </a>
            <a
              href={COMPANY_PROFILE_DOWNLOAD}
              download="RK_Overseas_Company_Profile.pdf"
              className="btn-outline"
              aria-label="Download RK Overseas Company Profile PDF"
            >
              ⬇ Download PDF
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
